import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { push } from 'react-router-redux';

import { getMemberData } from 'actions/member';

import App from 'layouts/App';

import LoginRoute from './Login';
import SignupRoute from './Signup';
import ForgetRoute from './Forget';
import MemberRoute from './Member';
import CourseRoute from './Course';
import VerifyRoute from './Verify';
import MemberCourseRoute from './MemberCourse';
import CouponRoute from './Coupon';
import ProductRoute from './Product';
import PrivacyRoute from './Privacy';
import ReserveRoute from './Reserve';
import BlogsRoute from './Blogs';
import OldLoginRoute from './OldLogin';
import SyncRoute from './Sync';
import ProcessRoute from './Process';
import EventRoute from './Event';

const createRoutes = store => ({
	path: '/',
	component: App,
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'Home',
			),
	},
	onEnter: () => {
		const { routing: { locationBeforeTransitions: { pathname } } } = store.getState();
		store.dispatch(getMemberData());
		if (pathname === '/') {
			store.dispatch(push('/member'));
		}
	},
	childRoutes: [
		LoginRoute(store),
		SignupRoute(store),
		BlogsRoute(store),
		ForgetRoute(store),
		MemberRoute(store),
		CourseRoute(store),
		VerifyRoute(store),
		MemberCourseRoute(store),
		CouponRoute(store),
		ProductRoute(store),
		PrivacyRoute(store),
		ReserveRoute(store),
		OldLoginRoute(store),
		SyncRoute(store),
		ProcessRoute(store),
		EventRoute(store),
	],
});

const Routes = ({ store, history }) => (
	<Provider store={store}>
		<Router key={Math.random()} history={history} routes={createRoutes(store)} />
	</Provider>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js